import { call, put, takeLatest } from "redux-saga/effects";
import {
    getApkStart,
    getApkSuccess,
    getApkFailure,

    addApkStart,
    addApkSuccess,
    addApkFailure
} from "../redux-slices/uploadApk";
import {  getAllApks , updateAllApks} from "../../utils/apiCalls";
import { toast } from "../../components/Toast";

export default function* transactionDriversWatcher() {
  yield takeLatest(getApkStart.type, getAllApksWorker);
  yield takeLatest(addApkStart.type, addApkStartWorker);

}

function* getAllApksWorker(action) {
  try {
    const { limit, pageNo } = action && action.payload
    const response = yield getAllApks({ limit, pageNo });

    yield put(getApkSuccess(response?.data?.data));
  } catch (error) {
    console.log("Failed to fetch data::::::::", error);

    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(
        getApkFailure(
        error?.response?.data?.errors[0]?.description
      )
    );
  }
}

function* addApkStartWorker(action) {
  try {
    const { data, onSuccess } = action && action.payload;

  const response =   yield updateAllApks(data?.formData);


    yield put(addApkSuccess());

    yield toast("APK Uploaded successfully", "success");

    if (onSuccess && typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (error) {

    yield toast(error?.response?.data?.errors[0]?.description, "error");
    yield put(addApkFailure(error?.response?.data?.errors[0]?.description))
  }
}



